/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown, faChevronUp, faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"
import { useEffect, useState } from "react"
import { Button, Card, Col, Collapse, Container, Form, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除, 画面ロック開始 } from "../../../globalStore/progressStore"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import dateUtil from "../../../ts/util/dateUtil"

import dayjs from "dayjs"
import ComboBox from "../../../components/ComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import DateInput from "../../../components/InputWrapper/DateInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import { 区分分類コード } from "../../../constant/enum/codes"
import { IS_INTERNAL_DEBUG_TOOL_ENABLED } from "../../../constant/internalDebugTool"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { RootState } from "../../../globalStore/rootreducer"
import KubunService from "../../../service/master/kubun/kubunService"
import {
  TDezitakoKintaiConfirmListGetReq,
  TDezitakoKintaiConfirmListGetRes,
} from "../../../service/truckcontrol/dezitako/TDegitako"
import DezitakoService from "../../../service/truckcontrol/dezitako/TDezitakoService"
import commonUtil from "../../../ts/util/commonUtil"
import { TWijmoComboBox } from "../../../type/wijmoComponents"

//#region [type]

export type Tデジタコ勤怠リスト = TDezitakoKintaiConfirmListGetRes & {
  /**
   * HH:mm表記
   */
  str出庫時刻?: string
  str入庫時刻?: string
  str勤務時間?: string
  str残業時間?: string
  str深夜時間?: string
  str休憩時間?: string
  str休息時間?: string
  str荷積時間?: string
  str荷卸時間?: string
  str待機時間?: string

  /**
   * yyyy/mm/dd表記
   */
  str出庫日?: string
  str入庫日?: string
  str勤務日?: string
}

//#endregion
/**
 * デジタコ勤怠確認
 * @returns
 */
const DezitakoKintaiKakunin = () => {
  const history = useHistory()
  const location = useLocation()
  const today = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "DezitakoKintaiKakunin_GridId"

  /**
   * 取込ファイル明細ビューアのURLを生成する。
   * aタグのhrefに実URLを持たせることで、中クリック/Ctrl+クリック時に
   * ブラウザ標準の「新規タブで開く」が正しく機能する
   * @param torikomiFileId 取込ファイルID
   */
  const createFileDetailUrl = (torikomiFileId?: number) =>
    `/truckcontrol/digitacho/filedetail?torikomiFileId=${torikomiFileId}`

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<TDezitakoKintaiConfirmListGetRes>, pageSize: number) => {
    const bindItems: Tデジタコ勤怠リスト[] = data.map((item) => {
      return {
        ...item,
      }
    })
    return new wjCore.CollectionView(bindItems, {
      pageSize,
      calculatedFields: {
        str出庫時刻: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.出庫時刻 ?? "") ? dateUtil.toTimeSpanString(item.出庫時刻!) : "",
        str入庫時刻: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.入庫時刻 ?? "") ? dateUtil.toTimeSpanString(item.入庫時刻!) : "",
        str休憩時間: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.休憩時間 ?? "") ? dateUtil.toTimeSpanString(item.休憩時間!) : "",
        str休息時間: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.休息時間 ?? "") ? dateUtil.toTimeSpanString(item.休息時間!) : "",
        str勤務時間: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.勤務時間 ?? "") ? dateUtil.toTimeSpanString(item.勤務時間!) : "",
        str残業時間: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.残業時間 ?? "") ? dateUtil.toTimeSpanString(item.残業時間!) : "",
        str深夜時間: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.深夜時間 ?? "") ? dateUtil.toTimeSpanString(item.深夜時間!) : "",
        str荷積時間: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.荷積時間 ?? "") ? dateUtil.toTimeSpanString(item.荷積時間!) : "",
        str荷卸時間: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.荷卸時間 ?? "") ? dateUtil.toTimeSpanString(item.荷卸時間!) : "",
        str待機時間: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.待機時間 ?? "") ? dateUtil.toTimeSpanString(item.待機時間!) : "",
        str出庫日: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.出庫日 ?? "") ? dateUtil.format(item.出庫日) : "",
        str入庫日: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.入庫日 ?? "") ? dateUtil.format(item.入庫日) : "",
        str勤務日: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.勤務日 ?? "") ? dateUtil.format(item.勤務日) : "",
        str更新日時: (item: Tデジタコ勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.更新日時 ?? "") ? dateUtil.format(item.更新日時, "YYYY/MM/DD HH:mm:ss") : "",
        sort_乗務員コード: (item: Tデジタコ勤怠リスト) =>
          commonUtil.createSortString(item.社員コード, VALIDATE_CONSTANT.LENGTH.社員コード),
        sort_車両コード: (item: Tデジタコ勤怠リスト) =>
          commonUtil.createSortString(item.車番, VALIDATE_CONSTANT.LENGTH.車番),
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }
  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TDezitakoKintaiConfirmListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    let currentSearchCondition: TDezitakoKintaiConfirmListGetReq

    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(createDisplaySearchCondition(currentSearchCondition))
    try {
      const res = await new DezitakoService().getList(currentSearchCondition)

      // 検索結果をstateにセット
      setGridData({
        data: createCollectionView(
          res.data.map((v) => {
            return {
              ...v,
            }
          }),
          pageSize,
        ),
      })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TDezitakoKintaiConfirmListGetReq = queryString.parse(location.search)
    set出庫日From(query.出庫日From)
    set出庫日To(query.出庫日To)
    setデジタコ種別区分コード(query.デジタコ種別区分コード)
    set社員コード(query.社員コード)
    set車番(query.車番)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TDezitakoKintaiConfirmListGetReq => {
    return {
      出庫日From: dateUtil.format(出庫日From) ?? undefined,
      出庫日To: dateUtil.format(出庫日To) ?? undefined,
      デジタコ種別区分コード: デジタコ種別区分コード ?? undefined,
      デジタコ種別区分ID:
        区分ItemSource?.find(
          (i) =>
            i.区分コード === デジタコ種別区分コード && i.分類コード === 区分分類コード.運行管理_勤怠.デジタコ種別区分,
        )?.区分ID ?? undefined,
      社員コード: 社員コード ?? "",
      車番: 車番 ?? "",
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (searchCondition: TDezitakoKintaiConfirmListGetReq) => {
    const disp出庫日From = dayjs(searchCondition.出庫日From).format("YYYY/MM/DD")
    const disp出庫日To = dayjs(searchCondition.出庫日To).format("YYYY/MM/DD")

    const dispデジタコ種別 = 区分ItemSource?.find(
      (i) =>
        i.区分コード === searchCondition.デジタコ種別区分コード &&
        i.分類コード === 区分分類コード.運行管理_勤怠.デジタコ種別区分,
    )?.名称1
    return {
      出庫日From: wjCore.isNullOrWhiteSpace(disp出庫日From ?? "") ? "" : disp出庫日From,
      出庫日To: wjCore.isNullOrWhiteSpace(disp出庫日To ?? "") ? "" : disp出庫日To,
      デジタコ種別: wjCore.isNullOrWhiteSpace(dispデジタコ種別 ?? "") ? "" : dispデジタコ種別,
      社員コード: 社員コード ?? "",
      車番: 車番 ?? "",
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)
    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set出庫日From(today)
    set出庫日To(today)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // 固定行ヘッダの設定
    for (let r = 0; r < f.rows.length; r++) {
      f.rowHeaders.setCellData(r, 0, r + 1)
    }

    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      const rowData: any = e.getRow().dataItem
      if (!rowData) return

      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)
  const [comboBoxDataInitialized, setComboBoxDataInitialized] = useState(false)

  // grid内エラー項目格納Array
  // const [errorCellPositionList] = useState<
  //   Array<{ 行ID: symbol; colBinding: string }>
  // >([])

  // modal

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [出庫日From, set出庫日From] = useState<string | null | undefined>(today)
  const [出庫日To, set出庫日To] = useState<string | null | undefined>(today)
  const [社員コード, set社員コード] = useState<string | undefined>()
  const [車番, set車番] = useState<string | undefined>()
  // ComboBoxState
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [デジタコ種別フラグComboBox, setデジタコ種別フラグComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [デジタコ種別フラグIsLoadEnded, setデジタコ種別フラグIsLoadEnded] = useState<boolean>(false)

  // 手入力モーダル
  const [isEdited, setIsEdited] = useState(false)

  // 設定
  const [デジタコ種別区分コード, setデジタコ種別区分コード] = useState<string | null | undefined>(null)

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)
      setComboBoxDataInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboBoxDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboBoxDataInitialized])

  useEffect(() => {
    if (isEdited && gridInitialized) {
      const querySearchCondition = queryParse()
      search(querySearchCondition)
      setIsEdited(false)
    }
  }, [isEdited])

  useEffect(() => {
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
    document.title = `デジタコ勤怠確認`
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">デジタコ勤怠確認</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-100rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon icon={accordionController ? faChevronDown : faChevronUp} size={"1x"} />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row ">
                            <div className="text-nowrap" style={{ padding: "0.5rem" }}>
                              出庫日
                            </div>
                            <div className="w-10rem">
                              <DateInput
                                id="出庫日From"
                                value={出庫日From}
                                defaultValue={today}
                                setValue={set出庫日From}
                                isRequired={true}
                                placeholder="出庫日From"
                                autoFocus={true}
                              />
                            </div>
                            <div style={{ width: "2rem", padding: "0.5rem" }}>～</div>
                            <div className="w-10rem">
                              <DateInput
                                id="出庫日To"
                                value={出庫日To}
                                defaultValue={today}
                                setValue={set出庫日To}
                                isRequired={true}
                                placeholder="出庫日To"
                                autoFocus={true}
                              />
                            </div>
                            <div className="text-nowrap" style={{ padding: "0.5rem" }}>
                              デジタコ種別
                            </div>
                            <ComboBox.Kubun
                              className="max-w-10rem"
                              placeholder="デジタコ種別"
                              autoFocus={true}
                              // isAllSelect={true}
                              itemsSource={区分ItemSource}
                              分類コード={区分分類コード.運行管理_勤怠.デジタコ種別区分}
                              selectedValue={デジタコ種別区分コード}
                              setSelectedValue={setデジタコ種別区分コード}
                              isLoadEnded={デジタコ種別フラグIsLoadEnded}
                              setIsLoadEnded={setデジタコ種別フラグIsLoadEnded}
                              ComboBox={デジタコ種別フラグComboBox}
                              setComboBox={setデジタコ種別フラグComboBox}></ComboBox.Kubun>
                            <div className="text-nowrap" style={{ padding: "0.5rem" }}>
                              乗務員コード
                            </div>
                            <TextInput
                              style={{ width: "8rem" }}
                              id="社員コード"
                              name="社員コード"
                              value={社員コード}
                              setValue={set社員コード}
                              maxLength={4}
                              placeholder="乗務員コード"
                            />
                            <div className="text-nowrap" style={{ padding: "0.5rem" }}>
                              車輌コード
                            </div>
                            <TextInput
                              style={{ width: "8rem" }}
                              id="車番"
                              name="車番"
                              value={車番}
                              setValue={set車番}
                              maxLength={4}
                              placeholder="車輌コード"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-start">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel displaySearchCondition={displaySearchCondition} />
                </Col>
              </Row>
              {/* 内部調査用リンクの案内（local環境のみ） */}
              {IS_INTERNAL_DEBUG_TOOL_ENABLED && (
                <Row>
                  <Col>
                    <div className="text-muted small">
                      ※local環境のため内部調査用リンクを表示中：日報番号のクリックで取込ファイル明細（調査用）へ遷移します
                    </div>
                  </Col>
                </Row>
              )}
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={`${gridId}_1`}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                gridProperties={{
                  allowAddNew: false,
                }}>
                <wjrGrid.FlexGridColumn
                  binding="デジタコ種別名称"
                  width={120}
                  header="デジタコ種別"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="日報番号" width={200} header="日報番号">
                  {IS_INTERNAL_DEBUG_TOOL_ENABLED && (
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(context: { item: Tデジタコ勤怠リスト }) => {
                        if (context.item.取込ファイルID == null) return <>{context.item.日報番号}</>
                        return (
                          <a
                            href={createFileDetailUrl(context.item.取込ファイルID)}
                            title="取込ファイル明細（調査用）を開く"
                            onClick={(e) => {
                              // 修飾キー付きクリックはブラウザ標準の新規タブ動作に任せる
                              // （中クリックはonClickを経由せずhrefで開かれる）
                              if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return
                              // 左クリックはリロードなしのSPA遷移にする
                              e.preventDefault()
                              history.push(createFileDetailUrl(context.item.取込ファイルID))
                            }}>
                            {context.item.日報番号}
                          </a>
                        )
                      }}
                    />
                  )}
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={125}
                  sortMemberPath="sort_乗務員コード"
                  header="乗務員コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="乗務員" width={125} header="乗務員"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車番"
                  width={100}
                  sortMemberPath="sort_車両コード"
                  header="車輌コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="登録番号" width={175} header="車両"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="str出庫日"
                  width={100}
                  wordWrap={true}
                  header="出庫日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str出庫時刻" width={100} header="出庫時刻"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="str入庫日"
                  width={100}
                  wordWrap={true}
                  header="入庫日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str入庫時刻" width={100} header="入庫時刻"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str勤務日" width={100} header="勤務日"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str勤務時間" width={60} header="勤務"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str残業時間" width={60} header="残業"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str深夜時間" width={60} header="深夜"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str休憩時間" width={60} header="休憩"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str休息時間" width={60} header="休息"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str荷積時間" width={60} header="荷積"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str荷卸時間" width={60} header="荷卸"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str待機時間" width={60} header="待機"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="走行距離" width={120} header="走行距離(km)"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="通行料合計" width={100} header="高速料"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="str更新日時" width={180} header="更新日時"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default DezitakoKintaiKakunin
